import React, { useState } from "react";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import { getAlert } from "../../Services/appAlerts";
import { validatePassword } from "../../Services/passwordValidator";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import { useResetPasswordMutation } from "../../app/store/authApiSlice";

const ResetPassword = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  const [resetPassword] = useResetPasswordMutation();

  const schema = {
    username: Joi.string().required().label("Username"),
    validId: Joi.string().required().label("Valid ID"),
    newPassword: Joi.string().required().min(8).max(14).label("New Password"),
    confirmPassword: Joi.string()
      .required()
      .valid(Joi.ref("newPassword"))
      .options({ language: { any: { allowOnly: "must match new password" } } })
      .label("Confirm Password"),
  };

  const doSubmit = async () => {
    const passResult = validatePassword(stateData["newPassword"]);
    if (passResult.isValid) {
      const { data: result } = await resetPassword(stateData);
      if (result === "error") {
        getAlert("Invalid Details", "", "error");
      } else {
        setIsSuccess(true);
      }
    } else {
      getAlert(
        "Strong Password Required",
        passResult.htmlMessage || passResult.message,
        "error"
      );
    }
  };

  const {
    stateData,
    stateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <div className="login-page">
      <div className="login-shell reset-password-shell">
        {/* <div className="login-top-banner">
          <i className="fa fa-shield" aria-hidden="true"></i>
          <span>Human Resources Information Management System (HRIMS)</span>
        </div> */}
        <section className="login-hero" aria-label="Reset password overview">
          <p className="login-kicker">Account Security</p>
          <h1>Reset your Password</h1>
          <div className="login-password-requirements">
            <p className="requirements-intro">
              <i className="fa fa-shield mr-2" aria-hidden="true"></i>
              Password requirements:
            </p>
            <ul className="requirements-list">
              <li>8 to 14 characters, no spaces</li>
              <li>Uppercase (A-Z) and lowercase (a-z) letters</li>
              <li>At least one number (0-9)</li>
              <li>At least one special character (!, @, #, $, %, etc.)</li>
            </ul>
          </div>
          <div className="login-highlights" aria-label="Reset steps">
            <span>Verify identity</span>
            <span>New password</span>
            <span>Secure access</span>
          </div>
        </section>

        <section className="login-panel" aria-label="Reset Password">
          <div className="login-card reset-password-card">
            {isSuccess ? (
              <React.Fragment>
                <div className="login-card-header text-center">
                  <i
                    className="fa fa-check-circle"
                    aria-hidden="true"
                    style={{ fontSize: "48px", color: "#298607" }}
                  ></i>
                  <h2 className="mt-3">Password Changed Successfully</h2>
                  <p>
                    Your password has been updated. You can now sign in
                    with your new credentials.
                  </p>
                </div>
                <Link
                  to="/Login"
                  className="btn btn-outline-default w-100"
                >
                  <i className="fa fa-sign-in mr-2" aria-hidden="true"></i>
                  Go to Login
                </Link>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="login-card-header reset-password-header">
                  <p className="login-step-label">Reset Password</p>
                  <Link
                    to="/Login"
                    className="btn btn-link btn-sm login-back reset-login-btn"
                  >
                    <i className="fa fa-sign-in" aria-hidden="true"></i>
                    Login
                  </Link>
                </div>

                <div className="reset-password-recovery">
                  <div className="row">
                    <div className="col-md-5">
                      {renderInput("validId", "Enter Your Valid ID")}
                    </div>
                    <div className="col-md-7">
                      {renderInput("username", "Enter Your Username")}
                    </div>
                    <div className="col-md-12">
                      {renderInput(
                        "newPassword",
                        "Enter New Password",
                        "password"
                      )}
                    </div>
                    <div className="col-md-12">
                      {renderInput(
                        "confirmPassword",
                        "Confirm Password",
                        "password"
                      )}
                    </div>
                    <div className="col-md-12">
                      <button
                        type="button"
                        className="btn btn-outline-default w-100"
                        disabled={!!validate()}
                        onClick={handleSubmit}
                      >
                        <i className="fa fa-check mr-2" aria-hidden="true"></i>
                        SUBMIT
                      </button>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </section>
        <div className="login-saas-banner">
          <i className="fa fa-cloud" aria-hidden="true"></i>
          <span>
            SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
          </span>
        </div>
        <div className="login-support-row">
          <a
            className="login-support-link"
            href="mailto:Support@workfinity.com"
            title="Support@workfinity.com"
          >
            <i className="fa fa-life-ring" aria-hidden="true"></i>
            <span>Customer Support</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
